import styled from 'styled-components';
import { Flex } from '@zillow/constellation';

export const StyledFlex = styled(Flex)`
  min-height: 300px;
`;
